var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.sessoes,"label":_vm.i18n(_vm.label),"outlined":_vm.outlined,"readonly":_vm.readonly,"clearable":_vm.clearable,"autofocus":_vm.autofocus,"prepend-inner-icon":_vm.icon,"hide-details":_vm.hideDetails},model:{value:(_vm.sessao),callback:function ($$v) {_vm.sessao=$$v},expression:"sessao"}})
}
var staticRenderFns = []

export { render, staticRenderFns }